"use client";

import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/shared/lib/utils";

// Soft, slowly drifting brand-green blobs that sit behind a section.
export const MeshBackground = ({ className }: { className?: string }) => {
    const reduce = useReducedMotion();

    return (
        <div
            aria-hidden
            className={cn(
                "pointer-events-none absolute inset-0 overflow-hidden",
                className,
            )}
        >
            {/* Top-left brand-green wash — kept very faint so it reads as a hint. */}
            <motion.div
                className="absolute -left-24 -top-24 size-[30rem] rounded-full bg-primary/[0.06] blur-3xl"
                animate={
                    reduce
                        ? undefined
                        : { x: [0, 40, 0], y: [0, 30, 0], scale: [1, 1.1, 1] }
                }
                transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
            />

            {/* Bottom-right wash, even softer and on a different rhythm. */}
            <motion.div
                className="absolute -bottom-32 -right-20 size-[26rem] rounded-full bg-primary/[0.04] blur-3xl"
                animate={
                    reduce
                        ? undefined
                        : { x: [0, -30, 0], y: [0, -40, 0], scale: [1, 1.15, 1] }
                }
                transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
            />
        </div>
    );
};
